/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BloodPressureProfileQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type BloodPressureProfileQuery = { __typename?: 'Query', bloodPressure: { __typename?: 'BloodPressure', id: string, systolicPressure: number | null, diastolicPressure: number | null, lastTreatedAt: string | null, controlledWithMedication: boolean | null, controlledWithMedicationSince: string | null }, currentUser: { __typename?: 'User', id: string, dateOfBirth: string | null } };

export type BloodPressureValuesFragment = { __typename?: 'BloodPressure', id: string, systolicPressure: number | null, diastolicPressure: number | null, lastTreatedAt: string | null, controlledWithMedication: boolean | null, controlledWithMedicationSince: string | null };

export const BloodPressureValuesFragmentDoc = gql`
    fragment BloodPressureValues on BloodPressure {
  id
  systolicPressure
  diastolicPressure
  lastTreatedAt
  controlledWithMedication
  controlledWithMedicationSince
}
    `;
export const BloodPressureProfileDocument = gql`
    query BloodPressureProfile {
  bloodPressure {
    id
    ...BloodPressureValues
  }
  currentUser {
    id
    dateOfBirth
  }
}
    ${BloodPressureValuesFragmentDoc}`;
export function useBloodPressureProfileQuery(baseOptions?: Apollo.QueryHookOptions<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>(BloodPressureProfileDocument, options);
      }
export function useBloodPressureProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>(BloodPressureProfileDocument, options);
        }
export function useBloodPressureProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>(BloodPressureProfileDocument, options);
        }
export type BloodPressureProfileQueryHookResult = ReturnType<typeof useBloodPressureProfileQuery>;
export type BloodPressureProfileLazyQueryHookResult = ReturnType<typeof useBloodPressureProfileLazyQuery>;
export type BloodPressureProfileSuspenseQueryHookResult = ReturnType<typeof useBloodPressureProfileSuspenseQuery>;
export type BloodPressureProfileQueryResult = Apollo.QueryResult<BloodPressureProfileQuery, BloodPressureProfileQueryVariables>;